import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/notfound.css';

const NotFound = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // Optional: Try to recover from common routing issues
        const path = location.pathname.toLowerCase();
        
        // Handle common route variations
        if (path.includes('/dashboard')) {
            navigate('/dashboard', { replace: true });
        } else if (path.includes('/profile')) {
            navigate('/profile', { replace: true });
        } else if (path.includes('/products')) {
            navigate('/products/all', { replace: true });
        }
    }, [location.pathname, navigate]);

    return (
        <div className="notfound-container">
            <h1>404</h1>
            <h2>Page non trouvée</h2>
            <p>La page que vous recherchez n'existe pas ou a été déplacée.</p>
            <div className="notfound-actions">
                <Link to="/" className="home-link">Retour à l'accueil</Link>
                <Link to="/dashboard" className="dashboard-link">Tableau de bord</Link>
                <button 
                    onClick={() => window.location.reload()} 
                    className="reload-button"
                >
                    Actualiser la page
                </button>
            </div>
        </div>
    );
};

export default NotFound;